export function
safeSum (numberA, numberB, precision = 100) {
  return (numberA * precision + numberB * precision) / precision
}

export function safeSumN (precision) {
  return (...args) => args.reduce((n, arg) => safeSum(n, arg, precision), 0)
}
